import React from "react";

export const ConditionGround = (props) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="190mm"
        height="70mm"
        style={{
          shapeRendering: "geometricPrecision",
          textRendering: "geometricPrecision",
          imageRendering: "optimizeQuality",
          fillRule: "evenodd",
          clipRule: "evenodd",
        }}
        viewBox="0 0 19000 7000"
        data-name="Layer 1"
        {...props}
      >
        <defs>
          <style type="text/css" />
        </defs>
        <g id="Layer_x0020_1">
          <metadata id="CorelCorpID_0Corel-Layer" />
          <path
            className="fil0"
            d="M10469.87 6847.41c2680.35,-466.26 5360.28,-933.76 8042.72,-1386.66 315.34,-53.43 462.21,-176.82 487.41,-459.66 0,-1537.03 0,-3074.06 0,-4611.09 -26.44,-296.48 -186.28,-393.99 -515.4,-389.86 -5954.47,67.2 -12010.71,67.2 -17965.18,0 -366.01,-4.59 -522.7,116.46 -519.36,497.14 12.96,1465.96 12.54,2931.92 0,4397.88 -2.92,358.97 139.14,505.9 491.37,565.59 2682.44,452.9 5362.37,920.4 8042.72,1386.66 1166.75,203.45 768.96,203.45 1935.72,0z"
          />
        </g>
      </svg>
    </>
  );
};
